import "./sliderProduct.scss";
import React, { useEffect, useRef, useState } from "react";
import productStore from "../../../store/productStore";
import { PRODUCT_IMAGE_URL } from "../../../constant";
import { Link } from "react-router-dom";
import categoryStore from "../../../store/categoryStore";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const ProductSlider = () => {
  const ProductStore = productStore();
  const sliderRef = useRef(null);
  const productWidthVW = 30;

  const sectionRef = useRef(null);
  const [auto, setAuto] = useState(true);

  // For drag
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeftStart, setScrollLeftStart] = useState(0);

  const scrollByVW = (vw) => {
    if (vw < 0) {
      setAuto(false);
    }

    const px = (vw / 100) * window.innerWidth;

    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: px, behavior: "smooth" });
    }
  };

  useEffect(() => {
    if (!auto) {
      setAuto(true);
    }
  }, [auto]);

  const onMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - sliderRef.current.offsetLeft);
    setScrollLeftStart(sliderRef.current.scrollLeft);
    sliderRef.current.style.cursor = "grabbing";
    sliderRef.current.style.userSelect = "none";
  };

  const onMouseLeave = () => {
    setIsDragging(false);
    if (sliderRef.current) {
      sliderRef.current.style.cursor = "grab";
      sliderRef.current.style.removeProperty("user-select");
    }
  };

  const onMouseUp = () => {
    setIsDragging(false);
    if (sliderRef.current) {
      sliderRef.current.style.cursor = "grab";
      sliderRef.current.style.removeProperty("user-select");
    }
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();

    const x = e.pageX - sliderRef.current.offsetLeft;
    const walk = (startX - x) * 1; // scroll-fast multiplier
    sliderRef.current.scrollLeft = scrollLeftStart + walk;
  };

  return (
    <div className="product-slider" ref={sectionRef}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 20px",
        }}
      >
        <div className="new-product-title">New Products</div>
        {/* <div className="button-container">
          <CircularProgressArrowButton
            direction={<ArrowBackIosNewIcon className="icon" />}
            onComplete={() => scrollByVW(-productWidthVW)}
          />

          <CircularProgressArrowButton
            key={auto}
            direction={<ArrowForwardIosIcon className="icon" />}
            // auto={auto}
            // isDurationApply
            onComplete={() => scrollByVW(productWidthVW)}
          />
        </div> */}
      </div>

      <div style={{ overflow: "hidden" }} className="slider-container-wrapper">
        <div className="btn-left-arrow">
          <CircularProgressArrowButton
            direction={<ArrowBackIosNewIcon className="icon" />}
            onComplete={() => scrollByVW(-productWidthVW)}
          />
        </div>
        <div
          className="scroll-container"
          ref={sliderRef}
          onMouseDown={onMouseDown}
          onMouseLeave={onMouseLeave}
          onMouseUp={onMouseUp}
          onMouseMove={onMouseMove}
        >
          {ProductStore.product &&
            ProductStore.product.map((product) => (
              <ProductCard key={product._id} product={product} />
            ))}
        </div>
        <div className="btn-right-arrow">
          <CircularProgressArrowButton
            key={auto}
            direction={<ArrowForwardIosIcon className="icon" />}
            // auto={auto}
            // isDurationApply
            onComplete={() => scrollByVW(productWidthVW)}
          />
        </div>
      </div>
    </div>
  );
};

const ProductCard = ({ product }) => {
  const CategoryStore = categoryStore();
  const [categoryName, setCategoryName] = useState();

  useEffect(() => {
    if (CategoryStore.category) {
      CategoryStore.category.filter((category) => {
        return (
          category._id === product.categoryID &&
          setCategoryName(category.categoryName)
        );
      });
    }
  }, [CategoryStore.category]);

  const cardStyle = {};

  const hoverBgStyle = {
    backgroundImage: `url(${PRODUCT_IMAGE_URL}${product.productImages[1]})`,
  };

  return (
    <Link
      draggable={false}
      to={`/${categoryName}/${product.productName}/${product._id}/details`}
      className="product-card"
      style={cardStyle}
    >
      <div style={hoverBgStyle} className="bg-img" />
      <img
        src={`${PRODUCT_IMAGE_URL}${product.productImages[0]}`}
        alt={product.productName}
        draggable={false}
      />
      <div className="back-shade"></div>
      <div className="basic-details">
        <h2>{product.productName}</h2>
        <div className="view-details">View Details</div>
      </div>
    </Link>
  );
};

export default ProductSlider;

const CircularProgressArrowButton = ({
  direction,
  onComplete,
  auto = false,
  isDurationApply = false,
}) => {
  const radius = 30;
  const stroke = 2;
  const normalizedRadius = radius - stroke / 2;
  const circumference = 2 * Math.PI * normalizedRadius;

  const [progress, setProgress] = useState(0);
  const [shouldAnimate, setShouldAnimate] = useState(true);
  const intervalRef = useRef(null);

  const clear = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  };

  const startProgress = () => {
    clear();
    if (isDurationApply && auto) {
      intervalRef.current = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            setShouldAnimate(false);
            setProgress(0);

            requestAnimationFrame(() => {
              setShouldAnimate(true);
            });

            onComplete?.();
            return 0;
          }
          return prev + 5;
        });
      }, 250);
    } else {
      onComplete?.();
    }
  };

  useEffect(() => {
    if (auto) {
      setProgress(0);
      startProgress();
    } else {
      clear();
      setProgress(0);
    }

    return () => clear();
  }, [auto]);

  const handleClick = () => {
    setProgress(0);
    onComplete?.();
    startProgress();
  };

  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div style={CircularProgressArrowButtonStyles.container}>
      {isDurationApply && (
        <svg
          height={radius * 2}
          width={radius * 2}
          style={{ transform: "rotate(-90deg)" }}
        >
          <circle
            stroke="#e0e0e0"
            fill="transparent"
            strokeWidth={stroke}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
          />
          <circle
            stroke="#00cc66"
            fill="transparent"
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            r={normalizedRadius}
            cx={radius}
            cy={radius}
            style={{
              transition: shouldAnimate
                ? "stroke-dashoffset 0.2s linear"
                : "none",
            }}
          />
        </svg>
      )}
      <button
        onClick={handleClick}
        style={{
          ...CircularProgressArrowButtonStyles.button,
          backgroundColor: "black",
          color: "white",
        }}
      >
        {direction}
      </button>
    </div>
  );
};

const CircularProgressArrowButtonStyles = {
  container: {
    position: "relative",
    width: 60,
    height: 60,
  },
  button: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 50,
    height: 50,
    borderRadius: "50%",
    border: "none",
    fontSize: 24,
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};
